module.exports = __webpack_public_path__ + "img/paulwilson.a2030b1b.png";